export const keys = {
    all: ["graph-report"],
    configurationLists: () => [
        ...keys.all,
        "configuration-list"
    ],
    configurationList: (
        groupID: number
    ) => [
            ...keys.configurationLists(),
            {
                groupID
            }
        ],
    fileStoreData: (
        groupID: number,
        fileStoreID: number | undefined
    ) => [
            ...keys.all,
            "filestore-data", {
                groupID,
                fileStoreID,
            }
        ]
};

